export enum TransactionState
{
    Clear = 0,
    Pending = 1,
    Settled = 2,
    Reversed = 3
}